/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantDomainBindingDto } from './TenantDomainBindingDto';
import {
    TenantDomainBindingDtoFromJSON,
    TenantDomainBindingDtoFromJSONTyped,
    TenantDomainBindingDtoToJSON,
    TenantDomainBindingDtoToJSONTyped,
} from './TenantDomainBindingDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface TenantDomainBindingResponse
 */
export interface TenantDomainBindingResponse {
    /**
     * 
     * @type {TenantDomainBindingDto}
     * @memberof TenantDomainBindingResponse
     */
    data?: TenantDomainBindingDto;
    /**
     * 
     * @type {string}
     * @memberof TenantDomainBindingResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof TenantDomainBindingResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof TenantDomainBindingResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof TenantDomainBindingResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the TenantDomainBindingResponse interface.
 */
export function instanceOfTenantDomainBindingResponse(value: object): value is TenantDomainBindingResponse {
    return true;
}

export function TenantDomainBindingResponseFromJSON(json: any): TenantDomainBindingResponse {
    return TenantDomainBindingResponseFromJSONTyped(json, false);
}

export function TenantDomainBindingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDomainBindingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : TenantDomainBindingDtoFromJSON(json['data']),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function TenantDomainBindingResponseToJSON(json: any): TenantDomainBindingResponse {
    return TenantDomainBindingResponseToJSONTyped(json, false);
}

export function TenantDomainBindingResponseToJSONTyped(value?: TenantDomainBindingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TenantDomainBindingDtoToJSON(value['data']),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

